var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrap md-elevation-1"},[_c('p',{staticClass:"md-body-1"},[_vm._v(_vm._s(_vm.message))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }